import API from '.';
import { StatusCodes } from 'http-status-codes';

export default class BuildingSourceSystemRelate {
  constructor({
    buildingSourceSystemId,
    buildingId,
    sourceSystemIdTypeId,
    sourceSystemReferenceId
  }) {
    this.BuildingSourceSystemId = buildingSourceSystemId;
    this.BuildingId = buildingId;
    this.SourceSystemIdTypeId = sourceSystemIdTypeId;
    this.SourceSystemReferenceId = sourceSystemReferenceId;
  }

  static async validateBuildingReferenceId(referenceId) {
    const api = await API();
    const response = await api.get(`BuildingSourceSystemRelate/ValidateBuildingReferenceId?referenceId=${referenceId}`);
    return response;
  }
}